import React from 'react'
import HomePage from '../components/templates/HomeTemplate'

const HomeScreen = () => {
  return (
    <HomePage/>
  )
}
export default HomeScreen